import AuthStorage from '../app/modules/authStorage';
import { getAuthTokens } from '../app/containers/TokenListPage/actions';

export const ENV = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
  METAMASK_MOBILE: 'metamask_mobile',
};

const setAuth = async (accessToken, refreshToken) => {
  AuthStorage.setTokens(accessToken, refreshToken);
};

export const connectWallet = async () => {
  if (window.ethereum) {
    try {
      const token = AuthStorage.getUserToken();
      const addressArray = await window.ethereum.request({
        method: 'eth_requestAccounts',
      });
      const walletAddress = addressArray[0];
      if (!token) {
        try {
          const authRes = await getAuthTokens({ walletAddress });
          const { accessToken, refreshToken } = authRes.data;
          await setAuth(accessToken, refreshToken);
        } catch (e) {
          console.log(
            `Failed to get auth tokens after connecting wallet: ${e}`,
          );
          return {
            address: '',
            status: '😥 ' + e.message,
          };
        }
      }
      return {
        status: `Connected!`,
        address: walletAddress,
      };
    } catch (err) {
      if (err.code === 4001) {
        return {
          address: '',
          status: err.message,
        };
      } else {
        return {
          address: '',
          status:
            'Already processing eth_requestAccounts. This is an issue by Metamask which will be fixed in next release. Meanwhile please re-click Metamask on your Browser Extensions on top right.',
        };
      }
    }
  } else {
    return {
      address: '',
      status:
        '🦊 You must install Metamask, a virtual Ethereum wallet, in your browser.',
    };
  }
};

export const getCurrentWalletConnected = async () => {
  if (window.ethereum) {
    try {
      const token = AuthStorage.getUserToken();
      const addressArray = await window.ethereum.request({
        method: 'eth_accounts',
      });
      if (addressArray.length > 0) {
        const walletAddress = addressArray[0];
        if (!token || token === 'undefined') {
          try {
            const authRes = await getAuthTokens({ walletAddress });
            const { accessToken, refreshToken } = authRes.data;
            await setAuth(accessToken, refreshToken);
          } catch (e) {
            console.log(
              `Failed to get auth tokens after connecting wallet: ${e}`,
            );
            return {
              address: '',
              status: '😥 ' + `${e.message}. Please contact admin.`,
            };
          }
        }
        return {
          address: walletAddress,
          status: 'Connected!',
        };
      } else {
        return {
          address: '',
          status: null,
        };
      }
    } catch (err) {
      return {
        address: '',
        status: '😥 ' + err.message,
      };
    }
  } else {
    return {
      address: '',
      status:
        'You must install Metamask, a virtual Ethereum wallet, in your browser.',
    };
  }
};
